import windows from "@/core/windows"
import context from "@/core/context"
import logger from "@/core/logger"

let bodyHtml: string | null
let bodyCopy: HTMLElement | null = null
/**
 * store the site's body at the point of first detection of placements
 * to facilitate the detection of dynamic placement targeting dynamic elements
 */
export function saveInitialBody() {
  if (!context.mode.isDebug() || bodyCopy) {
    return
  }
  try {
    bodyHtml = windows.site.document.body.outerHTML
  } catch (e) {
    logger.error("failed to copy body", e)
  }
}

export function initialBody() {
  if (bodyHtml && !bodyCopy) {
    const inertDoc = windows.site.document.implementation.createHTMLDocument("Inert")
    inertDoc.body.outerHTML = bodyHtml
    bodyCopy = inertDoc.body
    bodyHtml = null
  }
  return bodyCopy
}
